module.exports = __webpack_public_path__ + "assets/img/8_1679.7af0aacb.jpg";